import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { ServiceSpecificationService } from '../../../core/services/service/service-specification/service-specification.service'
import { MatSelectChange, MatSelectModule } from '@angular/material/select'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { PaymentMethodsService } from '../../../core/services/payment/payment-methods/payment-methods.service'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service'
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common'
import { VehicleModelService } from '../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import { convertCurrency } from '../../../shared/utils/utils'
import { ModalEmployeeConsultantComponent } from '../../employee/modal-employee-consultant/modal-employee-consultant.component'




import moment from 'moment'
import { ProposalStatusService } from '../../../core/services/proposal/proposal-status/proposal-status.service'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { ConsultantService } from '../../../core/services/person/consultant/consultant.service'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import {
  MatColumnDef,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { ProposalItemService } from '../../../core/services/proposal/proposal-item/proposal-item.service'
import { MatProgressBar } from '@angular/material/progress-bar'
import { ContractItemService } from '../../../core/services/contract/contract-item/contract-item.service'
import { ItemContractEditFormComponent } from '../item-contract-edit/item-contract-edit-form/item-contract-edit-form.component'
import { DriverUploadCreateFormComponent } from '../../driver/driver-upload-edit/driver-upload-create-form/driver-upload-create-form.component'
import { PersonDocumentService } from '../../../core/services/person/person-document/person-document.service'
import { ContractUploadComponent } from './contract-upload/contract-upload.component'
import { ContractClientService } from '../../../core/services/contract/contract-client/contract-client.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { ModalEmployeeConsultantOperationalClientComponent } from '../../employee/modal-employee-consultant-operational-client/modal-employee-consultant-operational-client.component'

@Component({
  selector: 'service-order-create',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatCard,
    MatIconModule,
    MatCardHeader,
    MatCardTitle,
    MatAccordion,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatColumnDef,
    MatSelectModule,
    MatProgressBar,
    MatPaginator,
    MatTableModule,
    ContractUploadComponent,
    MatProgressSpinner,
  ],
  templateUrl: './contract-create.component.html',
  styleUrl: './contract-create.component.scss',
  providers: [
    ServiceOrderService,
    provideNgxMask(),
    ProposalStatusService,
    PaymentMethodsService,
    EmployeeService,
  ],
  standalone: true,
})
export class ContractCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private paymentMethodsService: PaymentMethodsService,
    private commissionDividerService: CommissionDividerService,

    private serviceSpecificationService: ServiceSpecificationService,
    private contractItemservice: ContractItemService,
    private contractService: ContractClientService,
    private driverTypeService: DriverTypeService,
    private snackbar: SnackbarCustomService,
    private consultantService: ConsultantService,
    private vehicleModelService: VehicleModelService,
    private vehicleTpeService: VehicleTypeService,
    private dialogRef: MatDialogRef<ContractCreateComponent>,
    private dialog: MatDialog,
    private proposalStatusService: ProposalStatusService,
    private employeeService: EmployeeService,
    private legalEntityClientService: LegalEntityClientService,
    private proposalItemService: ProposalItemService,
    private personDocumentService: PersonDocumentService,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() response = new EventEmitter<any>()
  @Output() responseCreate = new EventEmitter()
  @ViewChild('birth') datepicker: MatDatepicker<any> | undefined
  @Output() responseEdit = new EventEmitter()
  @Input() proposalInfo: any = {}
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined
  @Input() idProposal = -1

  formLegalEntity: FormGroup = new FormGroup({})
  formIndividual: FormGroup = new FormGroup({})

  formFinancial: FormGroup = new FormGroup({})
  listTypeClient: any = [
    { id: 'legal', description: 'Pessoa Jurídica' },
    // { id: 'individual', description: 'Pessoa Fisica' },
  ]

  typeClient: 'legal' | 'individual' = 'legal'

  page = 1
  rows = 10
  numberRows = 0
  form: FormGroup = new FormGroup({})
  loading = false
  item: any = { user: false, data: [] }
  idClient = -1
  maxDate!: Date
  totalDocuments = 0

  documents: any[] = []
  ListProposalStatus: any[] = []
  ListPaymentMethods: any[] = []
  itemsList: any[] = []
  selectedFiles: File[] = []
  ListCommission: any[] = [
    { value: 0, description: 'Tgmob', disabled: false },
    { value: 1, description: 'Cliente', disabled: true },
    { value: 2, description: 'Personalizado', disabled: false },
  ]

  columnsDocuments = [
    { keyColumn: 'tipo', key: 'tipo', description: 'Tipo' },
    { keyColumn: 'description', key: 'descricao', description: 'Descrição' },
    { keyColumn: 'action', key: 'action', description: 'Ações' },
  ]

  displayedColumnsDocuments = ['tipo', 'description', 'action']

  columns: any[] = [
    {
      keyColumn: 'location_OD',
      key: 'cidadeOrigem',
      description: 'Trecho',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServicoDescricao',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculoDescricao',
      description: 'Veículo',
    },
    {
      keyColumn: 'dateStart',
      key: 'dataInicio',
      description: 'Data Início',
    },
    {
      keyColumn: 'dateEnd',
      key: 'dataFinal',
      description: 'Data Final',
    },

    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  searchForm: any = { search: false, model: {} }

  tableDocuments: MatTableDataSource<any> = new MatTableDataSource<any>()

  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = [
    'location_OD',
    'servico_TS',
    'vehicle_VM',
    'dateStart', // <-- Data Início
    'dateEnd',
    'action',
  ]

  listType = [
    { id: 'ativo', nome: 'Ativo' },
    { id: 'inativo', nome: 'Inativo' },
    { id: 'pendente', nome: 'Pendente' },
  ]

  ListItemsProposal: any[] = []
  vehicleTypeList: any[] = []
  listTypeDriver: any[] = []
  clientSelected: any = {}
  subClientSelected: any = {}
  consultantClientSelected: any = {}
  employeeConsultantSelected: any = {}
  employeeConsultantOpSelected: any = {}
  editIndex: number | null = null
  editAgendaItem: any = null

  clientId: any | null = null
  consultantOpId: number | null = null

  loadingAssociate = false

  commissionDividerClient: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  commissionDividerTg: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  ngOnInit(): void {
    this.listTypeVehicle()
    this.createForm()
    this.listTypeService()
    this.getDriverType()
    this.loadDocuments()

    if (this.data && this.data.id) {
      this.idProposal = this.data.id
    }

    this.getItemContractByContract()

    this.loadProposalStatusAndFillForm()

    if (this.data.consultorComercialId) {
      this.getConsultantComerce()
    }
    if (this.data.consultorOperacionalId) {
      this.consultantOpId = this.data.consultorOperacionalId
      this.fillConsultantOp()
    }
  }

  getDriverType() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: any) => {
        const list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listTypeDriver = list
      },
      error: (err: any) => {},
      complete: () => {},
    })
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  addFile() {
    const dialogRef = this.dialog.open(DriverUploadCreateFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '60vw',
      maxHeight: '100vh',
      height: '50vh',
      panelClass: 'dialog-fullscreen',
      data: { edit: true, proposalInfo: this.proposalInfo },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      this.uploadList()
    })
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement
    if (input.files) {
      // Concatena novos arquivos sem duplicar
      const filesArray = Array.from(input.files)
      filesArray.forEach((file) => {
        if (
          !this.selectedFiles.find(
            (f) => f.name === file.name && f.size === file.size,
          )
        ) {
          this.selectedFiles.push(file)
        }
      })
    }
  }

  searchContact() {
    this.loading = true
    this.proposalItemService
      .searchPagedProposalItem(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  removeFile(file: File) {
    this.selectedFiles = this.selectedFiles.filter((f) => f !== file)
  }

  editDocument(doc: any) {
    // Lógica para editar o documento (abrir modal, etc)
  }

  deleteDocument(doc: any) {
    // Lógica para deletar o documento (confirmar e chamar API)
  }

  loadDocuments() {
    this.loading = true
    this.personDocumentService
      .listPagedPersonDocumentById(
        this.data.clientePessoaId,
        this.page,
        this.rows,
      )
      .subscribe({
        next: (response: ResponseRequestModel) => {
          // Ajuste conforme o retorno da sua API
          const items = response.data?.items ?? response.data ?? []
          this.documents = items
          this.totalDocuments = response.data?.total ?? items.length
          this.tableDocuments = new MatTableDataSource<any>(this.documents)
          this.loading = false
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
      })
  }

  onPageChange(page: number) {
    this.page = page
    this.loadDocuments()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchContact()
    } else {
      this.getItemContractByContract()
    }
  }

  selectItemEvent(element: any) {
    this.item = element

    const dialogRef = this.dialog.open(ItemContractEditFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { edit: true, item: element, proposalInfo: this.proposalInfo },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      this.uploadList()
    })
  }

  getConsultantComerce() {
    this.employeeService
      .getEmployeebyId(this.data.consultorComercialId)
      .subscribe({
        next: (response) => {
          this.formLegalEntity.patchValue({
            consultantComercialCpf: response.data.cpf,
            consultantComercialEmail: response.data.email,
            consultantComerce: response.data.nome ?? '',
          })
        },
        // error(err) { console.error('Erro ao buscar consultor:', err); },
      })
  }

  loadProposalStatusAndFillForm() {
    // Supondo que você tenha um service para buscar os status
    this.proposalStatusService.listProposalStatus().subscribe({
      next: (response: ResponseRequestModel) => {
        this.ListProposalStatus = response.data

        if (this.data) {
          this.formLegalEntity.patchValue({
            eventName: this.data.nomeEvento ?? '',
            dateStart: this.data.dataInicio
              ? moment(this.data.dataInicio, 'DD/MM/YYYY').toDate()
              : null,
            dateEnd: this.data.dataFim
              ? moment(this.data.dataFim, 'DD/MM/YYYY').toDate()
              : null,
            client: this.data.nomeCliente ?? '',
            codigTg: this.data.codigoTg ?? '',
            subClient: this.data.nomeSubCliente ?? '',
            consultantClient: this.data.nomeConsultor ?? '',
            consultantClientId: this.data.consultorId ?? '',
            statusPropostaId: this.data.statusPropostaId ?? '',
            numPassengers: this.data.quantidadePassageiros ?? '',
            requesterName: this.data.solicitante ?? '',
            requesterEmail: this.data.solicitanteEmail ?? '',
            requesterPhone: this.data.solicitanteTelefone ?? '',
            grandTotal: this.data.valorTotal ?? 0,
          })
          if (this.data.consultorOperacionalId) {
          }

          // Buscar dados completos do consultor comercial, se houver ID
          if (this.data.consultorComercialId) {
            this.employeeService
              .getEmployeebyId(this.data.consultorComercialId)
              .subscribe({
                next: (response) => {
                  const consultor = response.data

                  this.formLegalEntity
                    .get('employeeConsultant')
                    ?.setValue(consultor.nome ?? '')
                  this.formLegalEntity
                    .get('consultantCpf')
                    ?.setValue(consultor.cpf ?? '')
                  this.formLegalEntity
                    .get('consultantEmail')
                    ?.setValue(consultor.email ?? '')
                  this.formLegalEntity.get('consultantPhone')?.setValue('')
                },
              })
          } else {
            this.formLegalEntity.get('consultantComerce')?.disable()
            this.formLegalEntity.get('consultantComercialCpf')?.disable()
            this.formLegalEntity.get('consultantComercialEmail')?.disable()
          }

          // Buscar dados completos do consultor cliente, se houver ID

          this.consultantService
            .listClientConsultant(this.data.consultorId)
            .subscribe({
              next: (response) => {
                const clientes = response.data
                if (Array.isArray(clientes) && clientes.length > 0) {
                  const clienteId = clientes[0].clienteId
                  this.clientId = clienteId

                  this.legalEntityClientService
                    .getLegalEntityClientbyId(clienteId)
                    .subscribe({
                      next: (response) => {
                        const cliente = response.data

                        this.formLegalEntity
                          .get('client')
                          ?.setValue(cliente.nomeFantasia)
                        this.formLegalEntity.get('cnpj')?.setValue(cliente.cnpj)
                        this.formLegalEntity
                          .get('corporate_name')
                          ?.setValue(cliente.razaoSocial)
                        this.formLegalEntity
                          .get('reg_state')
                          ?.setValue(cliente.inscricaoEstadual)
                        this.formLegalEntity
                          .get('reg_municipal')
                          ?.setValue(cliente.inscricaoMunicipal)
                      },
                    })
                  this.getPaymentMethod(clienteId)
                  this.consultantService
                    .listConsultantClientByPerson(clienteId)
                    .subscribe({
                      next: (response) => {
                        const consultorClienteArray = response.data
                        if (
                          Array.isArray(consultorClienteArray) &&
                          consultorClienteArray.length > 0
                        ) {
                          const consultorCliente = consultorClienteArray[0]

                          this.formLegalEntity
                            .get('consultantClient')
                            ?.setValue(consultorCliente.nome ?? '')
                          this.formLegalEntity
                            .get('consultantEmail')
                            ?.setValue(consultorCliente.email ?? '')
                          this.formLegalEntity
                            .get('consultantPhone')
                            ?.setValue(consultorCliente.telefone ?? '')
                          this.formLegalEntity
                            .get('consultantCpf')
                            ?.setValue('')
                        }
                        // else {
                        //   console.warn('Nenhum consultor cliente encontrado para este clienteId.');
                        // }
                      },
                    })
                  // Agora você pode usar o clienteId como quiser!
                }
                // else {
                //   console.warn('Nenhum cliente encontrado para este consultor.');
                // }

                // <-- Veja os dados aqui!
              },
            })

          // if (this.data.nomeConsultor === null) {
          //   this.formLegalEntity.get('consultantClient')!.disable();
          // }

          this.formLegalEntity.get('statusPropostaId')!.disable()

          this.formLegalEntity.get('grandTotal')
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
    })
  }

  listTypeVehicle() {
    this.vehicleTpeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.vehicleTypeList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  listTypeService() {
    // this.serviceTypeService.listServiceType().subscribe({
    //   next: (response: ResponseRequestModel) => {
    //     this.listType = response.data.map((item: any) => ({
    //       id: item.id,
    //       nome: item.descricao
    //     }));
    //   },
    //   error: (err: ResponseRequestModel) => {
    //     console.error(err)
    //   },
    //   complete: () => { },
    // })
  }

  getStatusDescricao(id: number): string {
    const status = this.ListProposalStatus?.find((s: any) => s.id === id)
    return status ? status.descricao : ''
  }

  getPaymentDescricao(id: number): string {
    const payment = this.ListPaymentMethods?.find((p: any) => p.id === id)
    return payment ? payment.tipoPagamento : ''
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.serviceSpecificationService
      .createServiceSpecification(model)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseCreate.emit()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.form.reset()
        },
      })
  }

  getItemContractByContract() {
    this.loading = true
    this.contractItemservice
      .getContractItembyIdContract(this.idProposal)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          // Origem/Destino
          cidadeOrigem: item.cidadeOrigem,
          cidadeDestino: item.cidadeDestino,
          // Tipo/Serviço
          tipoServicoDescricao: item.tipoServicoDescricao,
          serfvicoDescricao: item.serfvicoDescricao, // se quiser mostrar também
          // Veículo/Motorista
          tipoVeiculoDescricao: item.tipoVeiculoDescricao,
          tipoMotoristaDescricao: item.tipoMotoristaDescricao,
          // Datas
          dataInicio: item.dataInicio,
          dataFinal: item.dataFinal,
          // Valores (já vem formatados, mas garanta que não seja vazio)
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      descricao: this.form.controls['description'].value,
      tipoServicoId: this.form.controls['typeService'].value,
      exigeVeiculo: this.form.get('vehicle')!.value ? 'S' : 'N',
    }
  }

  createForm(): void {
    this.formLegalEntity = this.formBuilder.group({
      name: ['', [Validators.required]],
      cnpj: ['', [Validators.required]],
      corporate_name: ['', [Validators.required]],
      reg_state: [''],
      eventName: [''],
      dateStart: [''],
      codigTg: [''],
      dateEnd: [''],
      client: [''],
      subClient: [''],
      consultantClient: [''],
      consultantComerce: [''],
      consultantClientId: [''],
      employeeConsultant: [''],
      statusPropostaId: [''],
      reg_municipal: [''],
      numPassengers: ['', [Validators.required]],
      paymentMethod: [''],
      requesterName: ['', [Validators.required]],
      requesterEmail: ['', [Validators.required, Validators.email]],
      requesterPhone: ['', [Validators.required]],
      grandTotal: [0, [Validators.required]],
      consultantEmail: ['', [Validators.required, Validators.email]],
      consultantCpf: ['', [Validators.required]],
      consultantPhone: ['', [Validators.required]],
      nomeFantasia: [''],
      consultantComercialPhone: [''],
      consultantComercialCpf: [''],
      consultantComercialEmail: [''],
      consultantOperate: [''],
      consultantOperateCpf: [''],
      consultantOperateEmail: [''],
    })

    this.formLegalEntity.get('statusPropostaId')!.disable()
    this.formLegalEntity.get('subClient')!.disable()

    this.formLegalEntity.get('paymentMethod')!.disable()
  }

  fillCommission(commission: any, clear = false) {
    if (clear == false) {
      this.form
        .get('commission')!
        .setValue(convertCurrency(commission.comissao))
      this.form.get('commission')!.disable()
      this.form.get('tax')!.setValue(convertCurrency(commission.taxa))
      this.form.get('tax')!.disable()
      this.form.get('divider')!.setValue(convertCurrency(commission.divisor))
      this.form.get('divider')!.disable()
    } else {
      this.form.get('commission')!.setValue(convertCurrency(0))
      this.form.get('commission')!.enable()
      this.form.get('tax')!.setValue(convertCurrency(0))
      this.form.get('tax')!.enable()
      this.form.get('divider')!.setValue(convertCurrency(0))
      this.form.get('divider')!.enable()
    }
  }

  onSelectionChangeType(event: MatSelectChange) {
    if (event.value == 0) {
      this.fillCommission(this.commissionDividerTg)
    } else if (event.value == 1) {
      this.fillCommission(this.commissionDividerClient)
    } else {
      this.fillCommission('', true)
    }
  }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.clientSelected.id) {
            this.clientSelected = response.selection

            this.clearItem(['paymentMethod'])

            this.getPaymentMethod(this.clientSelected.formaPagamentoId)
            this.idClient = this.clientSelected.id
            this.getCommissionDivider(this.clientSelected.id)
          }
        } else {
          this.clearItem(['client', 'subClient', 'consultant', 'paymentMethod'])
          this.formLegalEntity.get('subClient')!.disable()
          this.formLegalEntity.get('consultant')!.disable()
          this.formLegalEntity.get('paymentMethod')!.disable()
          this.idClient = -1
          this.commissionDividerClient = {
            taxa: 0,
            divisor: 0,
            comissao: 0,
          }
          this.fillCommission(this.commissionDividerTg)
          this.formLegalEntity.get('typeCommission')!.setValue(0)
          this.ListCommission[1].disabled = true
        }
      }
    })
  }

  addEmployeeConsultant() {
    const dialogRef = this.dialog.open(ModalEmployeeConsultantComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.employeeConsultantSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.employeeConsultantSelected = response.selection
          this.formLegalEntity
            .get('employeeConsultant')!
            .setValue(this.employeeConsultantSelected.nome)
          this.formLegalEntity
            .get('consultantCpf')!
            .setValue(this.employeeConsultantSelected.cpf ?? '')
          this.formLegalEntity
            .get('consultantEmail')!
            .setValue(this.employeeConsultantSelected.email ?? '')
          this.formLegalEntity
            .get('consultantPhone')!
            .setValue(this.employeeConsultantSelected.telefone ?? '')
        } else {
          this.clearItem([
            'employeeConsultant',
            'consultantCpf',
            'consultantEmail',
            'consultantPhone',
          ])
        }
      }
    })
  }

  getPaymentMethod(id: number) {
    this.ListPaymentMethods = []
    this.paymentMethodsService.getPaymentMethodsbyId(id).subscribe({
      next: (response: ResponseRequestModel) => {
        // Se response.data for array, pegue o primeiro elemento
        const metodo = Array.isArray(response.data)
          ? response.data[0]
          : response.data
        this.ListPaymentMethods = response.data

        this.formLegalEntity
          .get('paymentMethod')!
          .setValue(metodo?.tipoPagamento ?? '')
        this.formLegalEntity.get('paymentMethod')!.enable()
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
    })
  }

  getCommissionDivider(id = -1) {
    if (id == -1) {
      this.commissionDividerService.getCommissionDividerDefault().subscribe({
        next: (response: ResponseRequestModel) => {
          this.commissionDividerTg = {
            taxa:
              response && response.data && response.data.taxa
                ? response.data.taxa
                : 0,
            divisor:
              response && response.data && response.data.divisor
                ? response.data.divisor
                : 1,
            comissao:
              response && response.data && response.data.comissao
                ? response.data.comissao
                : 0,
          }
          this.fillCommission(this.commissionDividerTg)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    } else {
      this.commissionDividerService
        .getCommissionDividerbyClientId(id)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            if (response.data) {
              this.commissionDividerClient = {
                taxa:
                  response && response.data && response.data.taxa
                    ? response.data.taxa
                    : 0,
                divisor:
                  response && response.data && response.data.divisor
                    ? response.data.divisor
                    : 1,
                comissao:
                  response && response.data && response.data.comissao
                    ? response.data.comissao
                    : 0,
              }
              this.ListCommission[1].disabled = false
              this.form.get('typeCommission')!.setValue(1)
              this.fillCommission(this.commissionDividerClient)
            } else {
              this.commissionDividerClient = {
                taxa: 0,
                divisor: 0,
                comissao: 0,
              }
              this.fillCommission(this.commissionDividerTg)
              this.form.get('typeCommission')!.setValue(0)
              this.ListCommission[1].disabled = true
            }
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
          },
          complete: () => {},
        })
    }
  }

  clearItem(items: string[]) {
    if (items.includes('client')) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
    }
    if (items.includes('subClient')) {
      this.subClientSelected = {}
      this.form.get('subClient')!.setValue('')
    }
    if (items.includes('consultant')) {
      this.consultantClientSelected = {}
      this.form.get('consultant')!.setValue('')
    }
    if (items.includes('employeeConsultant')) {
      this.employeeConsultantSelected = {}
      this.form.get('employeeConsultant')!.setValue('')
    }
    if (items.includes('paymentMethod')) {
      this.ListPaymentMethods = []
      this.form.get('paymentMethod')!.setValue('')
    }
  }

  fillConsultantOp() {
    this.formLegalEntity
      .get('consultantOperate')
      ?.setValue(this.data.nomeConsultorOperacional)
    this.formLegalEntity
      .get('consultantOperateEmail')
      ?.setValue(this.data.emailConsultorOperacional)
    this.formLegalEntity
      .get('consultantOperateCpf')
      ?.setValue(this.data.cpfConsultorOperacional)

    this.employeeConsultantOpSelected = {
      id: this.data.consultorOperacionalId,
      nome: this.data.nomeConsultorOperacional,
    }
  }

  associateConstOp() {
    const dialogRef = this.dialog.open(
      ModalEmployeeConsultantOperationalClientComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '1200px',
        minWidth: '1200px',
        maxHeight: '650px',
        data: {
          item: this.employeeConsultantOpSelected,
          idClient: this.data.subClienteId
            ? this.data.subClienteId
            : this.data.clienteId,
          multiSelect: false,
        },
      },
    )
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (
          response.associate == true &&
          response.selection.id >= 0 &&
          response.selection.id != this.employeeConsultantOpSelected.id
        ) {
          const model = {
            id: this.data.id,
            consultorOperacionalId: response.selection.id,
          }
          this.loadingAssociate = true
          this.contractService
            .editContractAssociateConsultantOperate(model)
            .subscribe({
              next: (responseAssociate: ResponseRequestModel) => {
                this.employeeConsultantOpSelected = response.selection
                this.formLegalEntity
                  .get('consultantOperate')
                  ?.setValue(this.employeeConsultantOpSelected.nome)
                this.formLegalEntity
                  .get('consultantOperateEmail')
                  ?.setValue(this.employeeConsultantOpSelected.email)
                this.formLegalEntity
                  .get('consultantOperateCpf')
                  ?.setValue(this.employeeConsultantOpSelected.cpf)
                this.loadingAssociate = false
                this.responseEdit.emit(true)
              },
              error: (err: ResponseRequestModel) => {
                console.error(err)
                this.loadingAssociate = false
              },
              complete: () => {
                this.loadingAssociate = false
              },
            })
        }
      }
    })
  }
}
